import api from './request'

export const recordQuestionResponse = async (
  sessionId: number,
  questionId: number,
  answer: string
) => {
  const response = await api.post(`/question-responses`, {
    session: sessionId,
    question: questionId,
    answer,
  })
  return response.data
}

export const viewQuestion = async (id: number, views: number) => {
  const response = await api.patch(`/questions/${id}`, {
    views,
  })
  return response.data
}
